import { createContext } from "react";
import type { MeResponse } from "@shortner/shared";

export interface WorkspaceContextValue {
  user: MeResponse["user"];
  workspace: MeResponse["workspace"];
}

export const WorkspaceContext = createContext<WorkspaceContextValue | null>(null);
